/**
 * FEC candidate office filters for Discover / candidate search.
 * OpenFEC offices: H (House), S (Senate), P (President).
 * President is only offered in presidential election years (e.g. 2024, 2028).
 */
import { FEC_DEFAULT_CYCLE } from "./fecApi";

export const CANDIDATE_OFFICE_H = "H";
export const CANDIDATE_OFFICE_S = "S";
export const CANDIDATE_OFFICE_P = "P";

export const CANDIDATE_OFFICE_OPTIONS = [
  { code: CANDIDATE_OFFICE_H, label: "House" },
  { code: CANDIDATE_OFFICE_S, label: "Senate" },
  { code: CANDIDATE_OFFICE_P, label: "President" },
];

export const DEFAULT_CANDIDATE_OFFICE = CANDIDATE_OFFICE_H;

/** True when the active FEC cycle is a presidential election year. */
export function isPresidentialElectionYear(year = FEC_DEFAULT_CYCLE) {
  return Number(year) % 4 === 0;
}

/** Office chips to render for the current election cycle. */
export function getVisibleCandidateOfficeOptions(electionYear = FEC_DEFAULT_CYCLE) {
  return CANDIDATE_OFFICE_OPTIONS.filter(
    (opt) => opt.code !== CANDIDATE_OFFICE_P || isPresidentialElectionYear(electionYear)
  );
}

/** Coerce to a visible office code; falls back to House when President is unavailable. */
export function normalizeCandidateOffice(office, electionYear = FEC_DEFAULT_CYCLE) {
  const code = String(office || DEFAULT_CANDIDATE_OFFICE).toUpperCase();
  const visible = getVisibleCandidateOfficeOptions(electionYear);
  if (visible.some((o) => o.code === code)) return code;
  return DEFAULT_CANDIDATE_OFFICE;
}

export function shouldShowDistrictForCandidateOffice(office) {
  return office === CANDIDATE_OFFICE_H;
}

/** House/Senate lists are large without a state; President is a smaller national set. */
export function shouldSuggestStateFilterForCandidates(office) {
  return office !== CANDIDATE_OFFICE_P;
}

export function getCandidateOfficeLabel(office) {
  const code = String(office || DEFAULT_CANDIDATE_OFFICE).toUpperCase();
  return CANDIDATE_OFFICE_OPTIONS.find((o) => o.code === code)?.label || "House";
}
